
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { appInfo, appInstance, department } from 'src/api';
import { message } from 'antd';

class ModulesAction extends ActionBasic<ModulesState> {

    public init = async () => {
        await this.getAppCategory();
        this.modulesState.searchInfo.appCategoryId = this.modulesState.appCategoryList[0].categoryId;
        this.getAppList();
    }

    // 清楚当前选择列表情况
    clearChecked = () => {
        this.modulesState.isCheckedAll = false;
        this.modulesState.checkedAppList.clear();
        this.setModulesState();
    }
    /** 
     * 获取app列表(判断类型 请求不同接口)
     */
    public getAppList = async () => {
        const type = this.modulesState.searchInfo.isOpen;
        //设置列表容器的滚动条回到顶部
        this.modulesState.carouselboxContent ? this.modulesState.carouselboxContent.scrollTop = 0 : null;
        this.clearChecked();
        if (type === 'myApp') {
            this.getCompanyQuery();
        } else {
            this.getAppListData();
        }
        this.getPermissionData();
    }
    /** 
     * 获取app列表 共有应用以及私有应用 无分页
     */
    public getAppListData = async () => {
        const { appCategoryId, isOpen } = this.modulesState.searchInfo;
        const param = {
            isOpen: isOpen === '0' || isOpen === '1' ? isOpen : undefined,
            appCategoryId: appCategoryId !== 0 ? appCategoryId : undefined,
        };
        const appData = await appInfo.appInfoQueryNoPage(this, param);
        if (!appData.er) {
            this.modulesState.appList = appData.res as any;
            this.setModulesState(this.modulesState);
        }
    }

    /**
     * 获取app列表 我的应用
     */
    public getCompanyQuery = async () => {
        const param = {
            appCategoryId: this.modulesState.searchInfo.appCategoryId === 0 ? undefined : this.modulesState.searchInfo.appCategoryId,
        };
        const appData = await appInstance.companyQueryNoPage(this, param);

        if (!appData.er) {
            this.modulesState.appList = appData.res as any;
            this.setModulesState(this.modulesState);
        }
    }

    /**
     * 采集需要的checkedAppList
     * @param e 
     * @param value 
     */
    public appCheckedListHandle = (e: any, value: any) => {
        const flag = this.modulesState.checkedAppList.has(value.appId);
        if (flag) {
            this.modulesState.checkedAppList.delete(value.appId);
        } else {
            this.modulesState.checkedAppList.add(value.appId);
        }

        this.setModulesState();
        this.isAppCheckedAll();
        // 根据appId获取授权信息
        this.getPermissionData();
    }

    isAppCheckedAll = () => {
        this.modulesState.isCheckedAll = this.modulesState.appList.filter(value => !!value.isActivated).
            every(item => this.modulesState.checkedAppList.has(item.appId));
        this.setModulesState();
    }
    /**
     * 根据相应的选择人员列表展示的tab页查询当前tab页的权限信息
     *
     * @memberof ModulesAction
     */
    public getPermissionData = () => {
        const type = this.modulesState.openTabVisible;
        if (type === 'department') { //部门
            this.permissionQuery(1);
        } else {
            this.permissionQuery(0);
        }
    }


    // app列表全选
    public checkedAll = () => {
        if (!this.modulesState.isCheckedAll) { // 当前为未全选
            this.modulesState.appList.forEach((item) => {
                const flag = this.modulesState.checkedAppList.has(item.appId);
                if (!flag && item.isActivated) {
                    this.modulesState.checkedAppList.add(item.appId);
                }
            });
        } else {
            this.modulesState.checkedAppList.clear();
        }
        this.modulesState.isCheckedAll = !this.modulesState.isCheckedAll;
        this.setModulesState();
        this.getPermissionData();
    }

    /** 获取app类型列表 */
    public getAppCategory = async () => {
        const appData = await appInstance.appCategory(this, {});
        if (!appData.er) {
            this.modulesState.appCategoryList = appData.res.list;
            this.setModulesState(this.modulesState);
        }
    }

    /** 查询公司 人员列表 无分页 */
    public companyUserQuery = async () => {
        const companyUserQuery = await appInstance.companyUserQueryNoPage(this);
        if (!companyUserQuery.er) {
            this.modulesState.companyUserList = companyUserQuery.res as any;
            this.modulesState.companyUserFilterList = companyUserQuery.res as any;
            this.setModulesState(this.modulesState);
        }
    }
    /** 获取应用权限: 部门 或 人员 */
    public permissionQuery = async (permissionType) => {
        const param = {
            appIdList: [...this.modulesState.checkedAppList],
            permissionType,
        };
        /** 权限类型 permissionType 0-表示用户，1-表示部门 */
        const appData = await appInstance.batchPermissionQuery(null, param);
        if (!appData.er) {
            if (permissionType === 1) {
                this.modulesState.permissionDepObjects = appData.res.permissionDepObjects || {};
                this.modulesState.activeDepObjects = appData.res.activeObjects;

            } else {
                this.modulesState.permissionUserObjects = appData.res.permissionUserObjects || {};
                this.modulesState.companyUserList = [];
                this.modulesState.activeUserObjects = appData.res.activeObjects;
                this.companyUserQuery();
            }
        }
        this.setModulesState(this.modulesState);
    }

    public buildTree = (data) => {
        let dataChildList = data.filter((item) => item.parentDepartmentId);
        let dataRootList = [];
        for (let i = 0; i < data.length; i++) {
            data[i].children = [];
            if (!data[i].parentDepartmentId) {
                dataRootList.push(data[i]);
            }
        }
        let tree = this.loopChildData(dataRootList, dataChildList);
        return tree;
    }
    private loopChildData = (parent, children, insert = false) => {
        for (let i = 0; i < parent.length; i++) {
            for (let x = 0; x < children.length; x++) {
                if (parent[i].departmentId === children[x].parentDepartmentId) {
                    parent[i].children.push(children[x]);
                }
            }
            if (parent[i].children.length > 0) {
                this.loopChildData(parent[i].children, children, true);
            }
        }
        if (insert) {
            return;
        } else {
            return parent;
        }
    }
    public departmentQuery = async () => {
        const res = await department.depList(this);
        if (!res.er) {
            this.modulesState.departmentQuery = res.res.map((item, index) => {
                return {
                    ...item,
                    value: item.departmentId,
                    key: index,
                    label: item.name,
                };
            });
            this.modulesState.departtreeDate = this.buildTree(this.modulesState.departmentQuery);
            this.modulesState.departmentFilterList = this.buildTree(this.modulesState.departmentQuery);
            this.modulesState.openTabVisible = 'companyUser';
            this.setModulesState();
        }
    }
    /**
     *  批量添加权限
     *
     * @param {*} item 当前选择节点信息
     * @param {boolean} flag 添加权限 | 移除权限 true | false
     * @param {number} [isDep=0] 是否是部门 1 是部门 0 是人员
     * @memberof ModulesAction
     */
    public setPowerHandle = (item: any, flag: boolean, isDep: number = 0) => {
        if (this.modulesState.checkedAppList.size === 0) {
            message.info('请选择需要授权的APP');
            return;
        }
        !isDep ? this.batchPermissionUser(item, flag) : this.batchPermissionDep(item, flag);
    }
    batchPermissionDep = (objInfo: any, flag: boolean) => {
        const objectType = 1;
        const powerData = { objectId: objInfo.departmentId, objectType };
        const permissionData = this.modulesState.permissionDepObjects;
        if (JSON.stringify(permissionData) === '{}') {
            this.modulesState.appList.filter(data => this.modulesState.checkedAppList.has(data.appId)).map(data => {
                let appPower = permissionData[data.appId];
                if (appPower) {
                    appPower.push(powerData);
                } else {
                    permissionData[data.appId] = [powerData];
                }
            });
        } else {
            this.modulesState.appList.filter(data => this.modulesState.checkedAppList.has(data.appId)).map(data => {
                let appPower = permissionData[data.appId];
                if (appPower) {
                    if (flag) { // 当前操作为添加权限
                        const hasPower = appPower.some(item => item.objectId === objInfo.departmentId);
                        if (!hasPower) {
                            appPower.push(powerData);
                        }
                    } else {
                        permissionData[data.appId] = appPower.filter(i => !(objInfo.departmentId === i.objectId));
                    }
                } else {
                    permissionData[data.appId] = [];
                    permissionData[data.appId].push(powerData);
                }

            });
        }
        this.setModulesState(this.modulesState, () => {
            this.batchPermissionOverride({
                permissionBizObjects: this.modulesState.permissionDepObjects,
                permissionType: objectType
            });
        });
    }
    /**
     * 
     *
     * @param {*} item 当前选择的人员信息
     * @param {boolean} flag flag 添加权限 | 移除权限 true | false
     * @memberof ModulesAction
     */
    batchPermissionUser = (objInfo: any, flag: boolean) => {
        const objectType = 0;
        const powerData = { objectId: objInfo.userId, objectType };
        const permissionData = this.modulesState.permissionUserObjects;
        if (JSON.stringify(permissionData) === '{}') {
            this.modulesState.appList.filter(data => this.modulesState.checkedAppList.has(data.appId)).map(data => {
                let appPower = permissionData[data.appId];
                if (appPower) {
                    appPower.push(powerData);
                } else {
                    permissionData[data.appId] = [powerData];
                }
            });
        } else {
            this.modulesState.appList.filter(data => this.modulesState.checkedAppList.has(data.appId)).map(data => {
                let appPower = permissionData[data.appId];
                if (appPower) {
                    if (flag) { // 当前操作为添加权限
                        const hasPower = appPower.some(item => item.objectId === objInfo.userId);
                        if (!hasPower) {
                            appPower.push(powerData);
                        }
                    } else {
                        permissionData[data.appId] = appPower.filter(i => !(objInfo.userId === i.objectId));
                    }
                } else {
                    permissionData[data.appId] = [];
                    permissionData[data.appId].push(powerData);
                }

            });
        }
        this.setModulesState(this.modulesState, () => {
            this.batchPermissionOverride({
                permissionBizObjects: this.modulesState.permissionUserObjects,
                permissionType: objectType
            });
        });

    }
    /**
     *  批量提交权限
     *
     * @param {*} params
     * @memberof ModulesAction
     */
    batchPermissionOverride = async (params: any) => {
        this.modulesState.spinningVisible = true;
        this.setModulesState();
        const appData = await appInstance.batchPermissionOverride(null, params);
        if (appData.res) {
            message.success('授权成功');
        }
        this.getPermissionData();
        this.modulesState.spinningVisible = false;
        this.setModulesState();

    }
    /**
     * 过滤当前有协作人员得部门
     * @param depHas 
     * @param data 
     * @returns 
     */
    public getDepartmentFilterListByTeamwork = () => {
        // 获取当前拥有协作人员得部门Array
        const activeUserList = this.modulesState.companyUserFilterList.filter(item => this.modulesState.activeUserObjects.indexOf(item.userId) !== -1).map(item => item.departmentId);
        if (activeUserList.length > 0) {
            // 在整体得部门树中过滤出拥有协作人员得部门树
            this.modulesState.departmentFilterListByTeamwork = this.filterList(activeUserList, JSON.parse(JSON.stringify(this.modulesState.departtreeDate)));
        } else {
            this.modulesState.departmentFilterListByTeamwork = [];
        }
        this.setModulesState();
    }
    /**
     * 过滤当前有公司人员得部门  暂未使用
     * @param depHas 
     * @param data 
     * @returns 
     */
      public getDepartmentFilterListByCompanyUser = () => {
        // 获取当前拥有协作人员得部门Array
        const activeUserList = this.modulesState.companyUserFilterList.map(item => item.departmentId);
        if(activeUserList.length > 0 ){
            // 在整体得部门树中过滤出拥有人员得部门树
            this.modulesState.departmentFilterListByCommanyUser = this.filterList(activeUserList, JSON.parse(JSON.stringify(this.modulesState.departtreeDate)));
        }else {
            this.modulesState.departmentFilterListByCommanyUser = [];
        }
        
        this.setModulesState();
    }
    /**
     *  判断当前部门及子部门下是否有相应的人员
     * @param ur 
     * @param dep 
     * @returns 
     */
    hasUser(ur: string[], dep: any) {
        let flag = false;
        if (ur.indexOf(dep.departmentId) > -1) {
            flag = true;
        } else {
            if (dep.children && dep.children.length > 0) {
                flag = dep.children.some(item => {
                    return this.hasUser(ur, item);
                });
            } else {
                flag = false;
            }
        }
        return flag;
    }
    /**
     * 过滤当前有协作人员得部门
     * @param depHas 
     * @param data 
     * @returns 
     */
    public filterList = (depHas: string[], data: any) => {
        const newData = data.filter(element => this.hasUser(depHas, element));
        newData.forEach(x => {
            if (x.children && x.children.length > 0) {
                x.children = this.filterList(depHas, x.children);
            }
        });
        return newData;
    }

}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/AppBatchSetPower/Modules.Action.ts